const CONFIG = {
  ignoreSubkey: new Set(["2pt", "3pt", "4pt", "turnover", "freeThrow", "goal", "technicalFault", "steal"]),
  includeSuccess: new Set(["2pt", "3pt", "4pt", "freeThrow", "goal", "sevenMetrePenalty"]),
  subkeyOverrides: new Set(["tipin"]),
  optionFields: {
    goal: "goalOutcome",
  },
  customTranslations: {
    turnover: "foulLedToTurnover",
  },
  sportMappings: {
    handball: {
      "event.turnover": "event.ballFault",
      "event.goal.false": "shot",
    },
  },
};

const shouldIgnoreSubkey = (eventType) => CONFIG.ignoreSubkey.has(eventType);
const shouldForceIncludeSubkey = (subType) => CONFIG.subkeyOverrides.has(subType);
const shouldIncludeSuccess = (eventType) => CONFIG.includeSuccess.has(eventType);
const getOptionFieldConfig = (eventType) => CONFIG.optionFields[eventType];
const getCustomTranslationField = (eventType) => CONFIG.customTranslations[eventType];
const getSportMapping = (translationKey, sport) => CONFIG.sportMappings[sport]?.[translationKey];

export const getEventTranslationKey = (event, sport, extraPlayInfo = {}) => {
  if (!event) {
    return null;
  }

  if (event.eventType === "foul" && event.options?.stopFoul) {
    return event.subType ? `event.foul.stopFoul.${event.subType}` : "event.foul.stopFoul";
  }

  let translationKey = "event." + event.eventType;

  // Add subType if applicable
  if (event.subType) {
    if (!shouldIgnoreSubkey(event.eventType) || shouldForceIncludeSubkey(event.subType)) {
      translationKey += "." + event.subType;
    }
  }

  // Add option field if configured
  const optionField = getOptionFieldConfig(event.eventType);
  if (optionField) {
    const optionValue = event.options?.[optionField];
    if (optionValue) {
      translationKey += "." + optionValue;
    }
  }

  // Add custom translation value if available
  const customField = getCustomTranslationField(event.eventType);
  const customValue = extraPlayInfo[customField];
  if (customValue) {
    translationKey += "." + customValue;
  }

  // Add success status if applicable
  if (typeof event.success === "boolean" && shouldIncludeSuccess(event.eventType)) {
    translationKey += "." + event.success;
  }

  // Apply sport-specific translation mapping
  const sportMapping = getSportMapping(translationKey, sport);
  if (sportMapping) {
    return sportMapping;
  }

  return translationKey;
};

export const getTechnicalFaultTranslationKey = (event) => {
  if (!event?.subType && !event?.options?.offensiveFoul) {
    return null;
  }

  return event?.options?.offensiveFoul
    ? "technicalFault.offensiveFoul"
    : "technicalFault." + event.subType;
};
